import { GridRowId } from '@mui/x-data-grid-pro';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  IntakeRequestSupplierSelectionGridField,
  useSupplierSelectionGridConfig,
} from '../../hooks/IntakeSupplierSelection.dataGrid';
import { I18nNamespace } from '~/common/types';
import { DeleteActionCell, editCellFactory, gridColDefFactory, UseDataGridConfig } from '~/components/DataGridCustom';
import { SupplierContactDataOptional } from '~/routes/IntakeDetail/components/SupplierContactForm/SupplierContactForm.schema';
interface UseSupplierSelectionGridConfigProps {
  onRowDelete: (id: GridRowId) => void;
  disabled?: boolean;
  includeSource?: boolean;
}

export const useRequestSupplierSelectionGridConfig: UseDataGridConfig<
  SupplierContactDataOptional,
  UseSupplierSelectionGridConfigProps
> = ({ onRowDelete, disabled, includeSource }) => {
  const { t } = useTranslation(I18nNamespace.intake);
  const { t: tColumn } = useTranslation(I18nNamespace.intake, {
    keyPrefix: 'SupplierSelectionGrid.column',
  });

  const config = useSupplierSelectionGridConfig({ onRowDelete, includeSource });

  return useMemo(() => {
    const createColumn = gridColDefFactory({ tColumn, t, defaultOptions: { sortable: false } });

    config.columns.push(
      createColumn({
        field: IntakeRequestSupplierSelectionGridField.DELETE_ACTION,
        minWidth: 72,
        width: 72,
        renderHeader: () => null,
        align: 'left',
        renderCell: editCellFactory(DeleteActionCell, {
          onClick: onRowDelete,
          disabled,
        }),
      }),
    );
    return config;
  }, [config, onRowDelete, disabled, t, tColumn]);
};
